module.exports = __webpack_public_path__ + "media/images/invoca/logo_thumb-796f318d5e35a9436ecc06ce9ca4bea4.png";